<template lang="pug">
.search-contract
    .row.m-0
        h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.searchContracts.title') }}
        el-form.formContainer.w-100.mb-4
            span.ml-2 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.searchContracts.searchInstructions') }}
            el-form-item.form-size.separator.custon-label.my-3(:rules='[{ required: true, trigger: "blur" }]')
                div.search-selects
                    div.select-flex
                        div
                            span {{ this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1') }}
                        el-select(
                            v-model='localidadeNivel1Selecionada',
                            filterable,
                            clearable,
                            value-key='id',
                            @change='buscarLocalidadeNivel2()',
                            @clear='clearLocation()'
                            :class='{ "error-border": $v.localidadeNivel1Selecionada.$error }',
                            :placeholder='$t("mensagens.comuns.selecione")'
                        )
                            el-option(
                                v-for='(localidadeNivel1, index) in localidadesNivel1',
                                :key='index',
                                :label='localidadeNivel1.nome',
                                :value='localidadeNivel1'
                            ) {{ localidadeNivel1.nome }}

                    div.select-flex.ml-4
                        div
                            span {{ this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2') }}
                        el-select(
                            v-model='localidadeNivel2Selecionada',
                            filterable,
                            clearable,
                            value-key='id',
                            :class='{ "error-border": $v.localidadeNivel2Selecionada.$error }',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            :no-data-text='$t("relatorio_rastreabilidade.messages.traceabilityReport.searchContracts.selectTheDepartment")'
                        )
                            el-option(
                                v-for='(localidadeNivel2, index) in localidadesNivel2',
                                :key='index',
                                :label='localidadeNivel2.nome',
                                :value='localidadeNivel2'
                            ) {{ localidadeNivel2.nome }}

                    div.select-flex.ml-4
                        div
                            span {{ this.$t('relatorio_rastreabilidade.messages.traceabilityReport.searchContracts.resale') }}
                        el-select(
                            v-model='revendaSelecionada',
                            filterable,
                            clearable,
                            value-key='id',
                            :class='{ "error-border": $v.revendaSelecionada.$error }',
                            :placeholder='$t("mensagens.comuns.selecione")'
                        )
                            el-option(
                                v-for='(revenda, index) in revendas',
                                :key='index',
                                :label='revenda.name',
                                :value='revenda'
                            ) {{ revenda.name }}

                    div.select-flex.button
                        BaseButton.btn-pesquisa(
                            type='primary',
                            @click='pesquisar'
                        )
                            | {{ $t('mensagens.comuns.pesquisar') }}

            contract-list(v-if='showContractList' :contratos='contratosPesquisados' :reportVolumeAvailable='reportVolumeAvailable' :contratosCarregados='contratosCarregados')
</template>

<script>
import LocalidadeService from '@/services/LocalidadeService';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import ContractList from '@/modules/traceability-report/views/components/search-contract/components/contract-list.vue';
import EventBus from '@/utils/eventBus';
export default {
    name: 'SearchContractDefault',
    components: {
        BaseButton,
        ContractList
    },
    data() {
        return {
            localidadesNivel1: [],
            localidadeNivel1Selecionada: {},
            localidadesNivel2: [],
            localidadeNivel2Selecionada: {},
            revendas: [],
            revendaSelecionada: {},
            contratosPesquisados: [],
            showContractList: false,
            reportVolumeAvailable: null,
            contratosCarregados: []
        };
    },
    validations: {
        localidadeNivel1Selecionada: {},
        localidadeNivel2Selecionada: {},
        revendaSelecionada: {}
    },
    watch: {
        localidadeNivel1Selecionada: {
            handler(newVal) {
                if (newVal) {
                    this.localidadeNivel2Selecionada = null;
                }
            }
        }
    },
    mounted() {
        this.buscarLocalidadeNivel1(5599);
        this.buscarRevendas();
        EventBus.$on('volume-input-updated', this.updateVolumeAdded);
        EventBus.$on('contratos-carregados-lista', this.updateLoadContracts);
    },
    methods: {
        async buscarLocalidadeNivel1(idLocalidadeNivel0) {
            const { data } = await LocalidadeService.findNivel1(idLocalidadeNivel0);
            this.localidadesNivel1 = data;
        },

        async buscarLocalidadeNivel2() {
            if (this.localidadeNivel1Selecionada && Object.keys(this.localidadeNivel1Selecionada).length !== 0) {
                const { data } = await LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id);
                this.localidadesNivel2 = data;
            }
        },

        async buscarRevendas() {
            const { data } = await RelatorioRastreabilidadeService.findAllPYClient();
            this.revendas = data;
        },

        async pesquisar() {
            try {
                this.$v.$touch();
                const { data } = await RelatorioRastreabilidadeService.findContractsByFilter(
                    this.localidadeNivel2Selecionada ? this.localidadeNivel2Selecionada.id : null,
                    this.localidadeNivel1Selecionada ? this.localidadeNivel1Selecionada.id : null,
                    this.revendaSelecionada ? this.revendaSelecionada.id : null);
                this.contratosPesquisados = data;
                this.showContractList = true;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.searchContracts.error')
                });
            }
        },

        updateVolumeAdded(volume) {
            this.reportVolumeAvailable = volume;
        },

        updateLoadContracts(contratosCarregados) {
            this.contratosCarregados = [...contratosCarregados];
        },

        clearLocation() {
            this.localidadesNivel2 = [];
            this.localidadeNivel2Selecionada = null;
        }
    }
};
</script>
<style lang='scss' scoped>
.formContainer {
    background-color: var(--white);
    border-radius: 5px;
    padding: 20px;
}

.el-collapse-item {
    border-bottom: 1px solid #ebeef5;
}

.el-form-item__label {
    margin-bottom: 0px;
}

.btn-pesquisa {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        margin-right: 5px;
    }
}

.required {
    margin-left: 2px;
    color: var(--red)
}

.required-text {
    font-size: 12px;
}

.form-size {
    width: 100%;
}

.separator {
    margin-right: 20px;
}

.search-selects {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: end;
    gap: 20px;
}

.select-flex {
    width: 26%;
    display: flex;
    flex-direction: column;
}

.select-flex.button {
    width: 10% !important;
}

.section-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: var(--primary-font-color);
}
</style>
